import { Component, Output, EventEmitter } from "@angular/core";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
@Component({
  selector: "app-modal-error",
  styleUrls: ["./modal-error.scss"],
  templateUrl: "./modal-error.html",
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
})
export class ModalErrorComponent {
  result;
  ticketTypesId: number;
  @Output() close = new EventEmitter<void>();

  constructor(@Inject(MAT_DIALOG_DATA) data: any) {
    this.result = data?.errors;
    this.ticketTypesId = data?.ticketTypesId;
  }

  ngOnInit() {
    this.ticketTypesId;
  }

  onCloseClick() {
    this.close.emit();
  }
}
